<ng-container *ngIf="scorecards$ | async as scorecards">
  <div class="fgbcl-featured-scorecards" *ngIf="scorecards.length">
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="fgbcl-subheading-title">{{ 'fgbcl.featured.challenges.heading' | translate }}</h5>
      <a class="d-flex align-items-center" [routerLink]="viewAllLink">
        <span class="font-size-14">{{ 'fgbcl.featured.view.all' | translate }}</span>
        <span class="material-icons font-size-14 fw-bold ps-2">arrow_forward_ios</span>
      </a>
    </div>

    <owl-carousel-o [options]="carouselOptions">
      <ng-container *ngFor="let scorecard of scorecards">
        <ng-template carouselSlide>
          <fgbcl-scorecards-v2-cards [scorecard]="scorecard" [hideLocked]="true" class="d-block"></fgbcl-scorecards-v2-cards>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</ng-container>
